/**
 * Accordion function
 */

const ToggleList = () => {
	/* eslint-disable-line */
	const toggleListHeadings = document.querySelectorAll(".toggle-list > li");
	const toggleListLinks = document.querySelectorAll(
		".toggle-list .toggle-link"
	);

	// set accordion default values
	Array.prototype.slice.call(toggleListHeadings).forEach(heading => {
		const toggleListHeading = heading;
		toggleListHeading.children[1].style.height = 0;
		toggleListHeading.children[0].classList.add("toggle-link_closed");
		toggleListHeading.children[0].setAttribute("aria-expanded", "false");
		toggleListHeading.children[0].setAttribute("role", "button");
		toggleListHeading.children[1].setAttribute("aria-hidden", "true");
	});

	Array.prototype.slice.call(toggleListLinks).forEach(toggleListLink => {
		toggleListLink.addEventListener("click", function() {
			/* eslint-disable-line */
			if (this.classList.contains("toggle-link_closed")) {
				this.setAttribute("aria-expanded", "true");
				this.nextElementSibling.classList.toggle("toggle-content_open");
				this.nextElementSibling.setAttribute("aria-hidden", "false");

				// Calculate height of toggle-content (inner height + margins)
				let calculateHeight = 0;
				const innerToggleContent = this.nextElementSibling.children;

				Array.prototype.slice.call(innerToggleContent).forEach(el => {
					const elStyle = getComputedStyle(el);
					calculateHeight +=
						el.offsetHeight +
						parseInt(elStyle.marginTop) +
						parseInt(
							elStyle.marginBottom
						); /* eslint-disable-line */
				});

				// Assigning full height for toggle-content
				this.nextElementSibling.style.height = `${calculateHeight}px`;
				this.classList.toggle("toggle-link_closed");
			} else {
				this.nextElementSibling.classList.toggle("toggle-content_open");
				this.nextElementSibling.style.height = 0;
				this.nextElementSibling.setAttribute("aria-hidden", "true");
				this.setAttribute("aria-expanded", "false");
				this.classList.toggle("toggle-link_closed");
			}
		});
	});
};

document.addEventListener("DOMContentLoaded", () => {
	const toggleList = document.querySelector(".toggle-list");

	if (toggleList) ToggleList();
});

export default ToggleList;
